// Struttura di navigazione del gestionale (stile AS/400): aree -> funzioni.
// Le rotte e i permessi sono quelli già esistenti: qui cambia solo la presentazione.

export const AREAS = [
  {
    key: "personale",
    title: "GESTIONE DEL PERSONALE",
    tone: {
      text: "text-sky-700 dark:text-sky-400", bar: "bg-sky-500",
      soft: "bg-sky-500/10", sel: "bg-sky-500/20 border-sky-500",
    },
    items: [
      { to: "/appello", label: "Appello Giornaliero", roles: ["admin", "manager"], testid: "nav-rollcall" },
      { to: "/presenze", label: "Calendario Presenze", roles: ["admin", "manager"], testid: "nav-calendar" },
      { to: "/situazione", label: "Situazione Dipendenti", roles: ["admin", "titolare", "manager"], testid: "nav-situation" },
      { to: "/richieste", label: "Ferie e Permessi", roles: ["admin", "titolare", "manager", "employee"], testid: "nav-requests" },
      { to: "/calendario-ferie", label: "Calendario Ferie", roles: ["admin", "titolare", "manager"], testid: "nav-vacation-calendar" },
      { to: "/certificati", label: "Certificati Malattia", roles: ["admin", "manager"], testid: "nav-certificates" },
      { to: "/dipendenti", label: "Anagrafica Dipendenti", roles: ["admin", "titolare", "manager", "rspp"], testid: "nav-employees" },
      { to: "/account-dipendenti", label: "Account Dipendenti", roles: ["admin", "manager"], testid: "nav-accounts" },
      { to: "/documenti", label: "Documenti e Buste Paga", roles: ["admin", "manager"], testid: "nav-documents" },
      { to: "/report", label: "Report Mensile", roles: ["admin", "manager"], testid: "nav-reports" },
      { to: "/dettaglio-giornaliero", label: "Dettaglio Giorno per Giorno", roles: ["admin", "manager"], testid: "nav-detail" },
      { to: "/mia-area", label: "La mia area", roles: ["employee"], testid: "nav-my-area" },
      { to: "/emergenze", label: "Registro Emergenze", roles: ["employee"], testid: "nav-emergency-employee", preposto: true },
      { to: "/malattia", label: "Malattia", roles: ["employee"], testid: "nav-my-sickness" },
      { to: "/miei-documenti", label: "I miei documenti", roles: ["employee"], testid: "nav-my-documents" },
      { to: "/archivio", label: "Archivio Documenti", roles: ["employee"], testid: "nav-archive-employee" },
    ],
  },
  {
    key: "pesi",
    title: "GESTIONE DEI PESI",
    tone: {
      text: "text-red-700 dark:text-red-400", bar: "bg-red-500",
      soft: "bg-red-500/10", sel: "bg-red-500/20 border-red-500",
    },
    items: [
      { to: "/pesi/consultazione", label: "Consultazione Pesi", roles: ["admin", "manager", "titolare"], testid: "nav-weights-view" },
      { to: "/pesi/registro", label: "Pesi Lavorazione", roles: ["admin", "manager"], testid: "nav-weights-entries" },
      { to: "/pesi/divisione", label: "Divisione Pesi", roles: ["admin", "manager"], testid: "nav-weights-split" },
      { to: "/pesi/cottimisti", label: "Cottimisti", roles: ["admin", "manager", "titolare"], testid: "nav-piecework" },
      { to: "/pesi/lavorazioni", label: "Lavorazioni", roles: ["admin", "manager"], testid: "nav-weights-products" },
      { to: "/pesi/report", label: "Report Pesate", roles: ["admin", "manager", "titolare"], testid: "nav-weights-report" },
      { to: "/miei-pesi", label: "I miei pesi", roles: ["employee"], testid: "nav-my-weights", piecework: true },
    ],
  },
  {
    key: "sicurezza",
    title: "GESTIONE SICUREZZA",
    tone: {
      text: "text-emerald-700 dark:text-emerald-400", bar: "bg-emerald-500",
      soft: "bg-emerald-500/10", sel: "bg-emerald-500/20 border-emerald-500",
    },
    items: [
      { to: "/sicurezza/consegne", label: "Registro Consegna DPI", roles: ["admin", "manager", "rspp"], testid: "nav-ppe-assign" },
      { to: "/sicurezza/consegne-attrezzature", label: "Registro Consegna Attrezzature", roles: ["admin", "manager", "rspp"], testid: "nav-tool-deliveries" },
      { to: "/sicurezza/assegnazioni", label: "DPI Assegnati", roles: ["admin", "manager"], testid: "nav-ppe-assigned" },
      { to: "/emergenze", label: "Registro Emergenze", roles: ["admin", "manager", "rspp"], testid: "nav-emergency" },
      { to: "/sicurezza/documenti-rspp", label: "Documenti Sicurezza / RSPP", roles: ["admin", "manager", "rspp"], testid: "nav-safety-docs" },
      { to: "/preposti", label: "Preposti", roles: ["admin"], testid: "nav-supervisors" },
      { to: "/sicurezza/registro", label: "Registro Preposto", roles: ["admin", "manager", "rspp"], testid: "nav-supervisor-log" },
      { to: "/miei-dpi", label: "I miei DPI", roles: ["employee"], testid: "nav-my-ppe" },
    ],
  },
  {
    key: "qualita",
    title: "CONTROLLO QUALITÀ",
    tone: {
      text: "text-cyan-700 dark:text-cyan-400", bar: "bg-cyan-500",
      soft: "bg-cyan-500/10", sel: "bg-cyan-500/20 border-cyan-500",
    },
    items: [
      { to: "/pesi/controllo-disosso", label: "Controllo Disosso", roles: ["admin", "manager"], testid: "nav-disosso-control" },
      { to: "/checklist-pulizie/archivio", label: "Check List Pulizie", roles: ["admin", "manager"], testid: "nav-checklist-archive" },
    ],
  },
  {
    key: "amministrazione",
    title: "AMMINISTRAZIONE",
    tone: {
      text: "text-amber-700 dark:text-amber-500", bar: "bg-amber-500",
      soft: "bg-amber-500/10", sel: "bg-amber-500/20 border-amber-500",
    },
    items: [
      { to: "/report-fine-mese", label: "Stampa Fine Mese", roles: ["admin", "manager"], testid: "nav-month-end" },
      { to: "/archivio", label: "Archivio Documenti", roles: ["admin", "manager", "titolare"], testid: "nav-archive" },
      { to: "/aziende", label: "Aziende", roles: ["admin"], testid: "nav-companies" },
      { to: "/tabelle", label: "Tabelle", roles: ["admin", "manager"], testid: "nav-tables" },
      { to: "/reparti", label: "Reparti", roles: ["admin", "manager"], testid: "nav-departments" },
      { to: "/importa", label: "Importa Dipendenti", roles: ["admin"], testid: "nav-import" },
      { to: "/utenti", label: "Utenti", roles: ["admin"], testid: "nav-users" },
      { to: "/impostazioni", label: "Impostazioni", roles: ["admin", "titolare"], testid: "nav-settings" },
      { to: "/audit", label: "Registro Modifiche", roles: ["admin"], testid: "nav-audit" },
      { to: "/configurazione-menu", label: "Configurazione Menu", roles: ["admin"], testid: "nav-menu-config" },
    ],
  },
];

// voci consentite per ruolo: identiche a quelle del vecchio menu laterale
const ALLOWED = {
  titolare: ["nav-calendar", "nav-requests", "nav-vacation-calendar", "nav-situation",
             "nav-employees", "nav-documents", "nav-settings",
             "nav-archive", "nav-weights-view", "nav-piecework", "nav-weights-report"],
  manager: ["nav-rollcall", "nav-calendar", "nav-employees",
            "nav-requests", "nav-vacation-calendar", "nav-certificates", "nav-documents", "nav-reports",
            "nav-detail", "nav-situation", "nav-ppe-assign", "nav-tool-deliveries", "nav-ppe-assigned",
            "nav-supervisor-log", "nav-emergency", "nav-safety-docs",
            "nav-checklist-archive",
            "nav-weights-view", "nav-weights-entries", "nav-weights-split", "nav-disosso-control",
            "nav-piecework", "nav-weights-products", "nav-weights-report", "nav-month-end",
            "nav-archive", "nav-departments", "nav-tables", "nav-accounts"],
};

export const areasFor = (user) => {
  const roles = user?.role === "titolare" ? ["titolare", "manager"] : [user?.role];
  const allowed = ALLOWED[user?.role];
  return AREAS
    .map((a) => ({ ...a, items: a.items.filter((n) => n.roles.some((r) => roles.includes(r))
      && (!n.piecework || user?.is_piecework)
      && (!n.preposto || user?.is_preposto)
      && (!allowed || allowed.includes(n.testid))) }))
    .filter((a) => a.items.length > 0);
};

/** Area a cui appartiene la rotta corrente (per breadcrumb e pulsante ESCI). */
export const areaOfPath = (user, pathname) => {
  const aree = areasFor(user);
  let best = null;
  aree.forEach((a) => a.items.forEach((it) => {
    if (pathname === it.to || pathname.startsWith(`${it.to}/`)) {
      if (!best || it.to.length > best.item.to.length) best = { area: a, item: it };
    }
  }));
  return best;
};

/** Catalogo delle pagine operative del gestionale (solo pagine vere, nessun endpoint tecnico). */
export const PAGES = [
  { to: "/appello", label: "Appello Giornaliero", area: "personale" },
  { to: "/presenze", label: "Calendario Presenze", area: "personale" },
  { to: "/situazione", label: "Situazione Dipendenti", area: "personale" },
  { to: "/richieste", label: "Ferie e Permessi", area: "personale" },
  { to: "/calendario-ferie", label: "Calendario Ferie", area: "personale" },
  { to: "/certificati", label: "Certificati Malattia", area: "personale" },
  { to: "/dipendenti", label: "Anagrafica Dipendenti", area: "personale" },
  { to: "/account-dipendenti", label: "Account Dipendenti", area: "personale" },
  { to: "/documenti", label: "Documenti e Buste Paga", area: "personale" },
  { to: "/report", label: "Report Mensile", area: "personale" },
  { to: "/dettaglio-giornaliero", label: "Dettaglio Giorno per Giorno", area: "personale" },
  { to: "/dashboard", label: "Dashboard Presenze", area: "personale" },
  { to: "/mia-area", label: "La mia area", area: "personale" },
  { to: "/malattia", label: "Malattia", area: "personale" },
  { to: "/miei-documenti", label: "I miei documenti", area: "personale" },
  { to: "/pesi/consultazione", label: "Consultazione Pesi", area: "pesi" },
  { to: "/pesi/registro", label: "Pesi Lavorazione", area: "pesi" },
  { to: "/pesi/divisione", label: "Divisione Pesi", area: "pesi" },
  { to: "/pesi/cottimisti", label: "Cottimisti", area: "pesi" },
  { to: "/pesi/lavorazioni", label: "Lavorazioni", area: "pesi" },
  { to: "/pesi/report", label: "Report Pesate", area: "pesi" },
  { to: "/miei-pesi", label: "I miei pesi", area: "pesi" },
  { to: "/sicurezza/consegne", label: "Registro Consegna DPI", area: "sicurezza" },
  { to: "/sicurezza/consegne-attrezzature", label: "Registro Consegna Attrezzature", area: "sicurezza" },
  { to: "/sicurezza/assegnazioni", label: "DPI Assegnati", area: "sicurezza" },
  { to: "/sicurezza/dpi", label: "DPI e Attrezzature", area: "sicurezza" },
  { to: "/sicurezza/attrezzature", label: "Attrezzi da Lavoro", area: "sicurezza" },
  { to: "/sicurezza/documenti-rspp", label: "Documenti Sicurezza / RSPP", area: "sicurezza" },
  { to: "/sicurezza/registro", label: "Registro Preposto", area: "sicurezza" },
  { to: "/preposti", label: "Preposti", area: "sicurezza" },
  { to: "/emergenze", label: "Registro Emergenze", area: "sicurezza" },
  { to: "/miei-dpi", label: "I miei DPI", area: "sicurezza" },
  { to: "/pesi/controllo-disosso", label: "Controllo Disosso", area: "qualita" },
  { to: "/checklist-pulizie/archivio", label: "Check List Pulizie", area: "qualita" },
  { to: "/report-fine-mese", label: "Stampa Fine Mese", area: "amministrazione" },
  { to: "/archivio", label: "Archivio Documenti", area: "amministrazione" },
  { to: "/aziende", label: "Aziende", area: "amministrazione" },
  { to: "/tabelle", label: "Tabelle", area: "amministrazione" },
  { to: "/reparti", label: "Reparti", area: "amministrazione" },
  { to: "/importa", label: "Importa Dipendenti", area: "amministrazione" },
  { to: "/utenti", label: "Utenti", area: "amministrazione" },
  { to: "/impostazioni", label: "Impostazioni", area: "amministrazione" },
  { to: "/audit", label: "Registro Modifiche", area: "amministrazione" },
  { to: "/configurazione-menu", label: "Configurazione Menu", area: "amministrazione" },
];

export const ROUTES = PAGES.map((p) => p.to);
